import { PlayerCapabilities } from 'ATVWebPlayer'
import { store } from '../store'
import { DetailPageActionTypes } from './constants'
import { playbackIdToCanonicalIdSelector } from '../selectors/player'
import {
  PlayerContentConfig,
  PlaybackContentLink,
} from '@shared'
import { refreshActionBoxes } from './actionBox'

export interface ISetPlayerCapabilities {
  type: typeof DetailPageActionTypes.SetPlayerCapabilities
  payload: {
    capabilities: PlayerCapabilities
  }
}

export interface IPlaybackStart {
  type: typeof DetailPageActionTypes.PlaybackStart
  payload: PlaybackContentLink
}

export interface IPlaybackFailed {
  type: typeof DetailPageActionTypes.PlaybackFailed
}

export interface IPlaybackClosed {
  type: typeof DetailPageActionTypes.PlaybackClosed
  payload: {
    content: PlayerContentConfig
  }
}

export const setPlayerCapabilities = (
  capabilities: PlayerCapabilities
): ISetPlayerCapabilities => ({
  type: DetailPageActionTypes.SetPlayerCapabilities,
  payload: {
    capabilities,
  },
})

export const startPlayback = (
  payload: PlaybackContentLink
): IPlaybackStart => ({
  type: DetailPageActionTypes.PlaybackStart,
  payload,
})

export const playerClosedOrTitleChanged = (
  opts: PlayerContentConfig,
  isClosed = true,
  shouldRefreshActionBoxes = true
) => {
  if (isClosed) {
    store.dispatch({
      type: DetailPageActionTypes.PlaybackClosed,
      payload: {
        content: opts,
      },
    })
  }
  const state = store.getState()
  const canonicalTitleIdMap = playbackIdToCanonicalIdSelector(state)
  if (shouldRefreshActionBoxes && opts && !opts.trailer && opts.asin) {
    const canonicalTitleId =
      (canonicalTitleIdMap && canonicalTitleIdMap[opts.asin]) || opts.asin
    refreshActionBoxes(canonicalTitleId)
  }
}
